import { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
} from "@mui/material";

interface EditIgnitionRegimeModalProps {
  open: boolean;
  onClose: () => void;
  onEdit: (name: string) => Promise<void>;
  initialName: string;
}

export default function EditIgnitionRegimeModal({
  open,
  onClose,
  onEdit,
  initialName,
}: EditIgnitionRegimeModalProps) {
  const [name, setName] = useState(initialName);

  useEffect(() => {
    setName(initialName);
  }, [initialName]);

  const handleSubmit = async () => {
    await onEdit(name);
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Edit Ignition Regime</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          label="Ignition Regime Name"
          type="text"
          fullWidth
          value={name}
          onChange={(e) => setName(e.target.value)}
          sx={{ mt: 1 }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleSubmit} variant="contained" color="primary">
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}
